import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { findingViewSectionType_Graph, findingViewType_Sections } from '@app/advisor-ui-shared';
import { _className, ComponentSync, Grid, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_Vitals.scss';
import { exists, sortArray } from '@nu-art/ts-common';
import { translate_VitalsResult_TooltipData } from './utils/translate-tooltip-results.js';
import { Tooltip_Finding_Vitals } from '../../Tooltip_Finding/tooltip/Tooltip_Finding_Vitals/Tooltip_Finding_Vitals.js';
import { ModuleFE_MeasurementUnit, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { ICONS } from '@app/styles';
export class Component_Vitals extends ComponentSync {
    modules = {
        variable: ModuleFE_Variable,
        value: ModuleFE_Value,
        measurementUnit: ModuleFE_MeasurementUnit,
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.findingView = nextProps.findingView;
        state.results = nextProps.results;
        return state;
    }
    // ######################## Logic ########################
    getSections = () => {
        if (this.state.findingView?.type !== findingViewType_Sections)
            return [];
        return this.state.findingView.sections.filter(section => section.type === findingViewSectionType_Graph);
    };
    getResultsForSection = (section) => {
        return section.data.variableIds.reduce((results, varId) => {
            if (this.state.results[varId]) {
                results[varId] = { ...this.state.results[varId] };
                //Filter out previous encounter results
                results[varId].results = results[varId].results.filter(result => result.currentVisit);
                //Sort results by timestamp
                sortArray(results[varId].results, result => result.timestamp, true);
            }
            return results;
        }, {});
    };
    getCellResult = (section, results) => {
        const latestResultsPerVarId = section.data.variableIds.map(varId => results[varId]?.results[0]);
        const firstVarSecondLatestResult = results[section.data.variableIds[0]]?.results[1];
        //Calculate trend by the results of the first variable in the section
        const trend = (!exists(firstVarSecondLatestResult) || !exists(latestResultsPerVarId[0]) || firstVarSecondLatestResult.value === latestResultsPerVarId[0]?.value)
            ? undefined
            : (firstVarSecondLatestResult.value > latestResultsPerVarId[0].value ? 'down' : 'up');
        if (!latestResultsPerVarId.filter(i => i).length)
            return { value: 'N/A', status: 'missing', trend };
        const latestTimestamp = Math.max(...latestResultsPerVarId.map(result => result?.timestamp ?? 0));
        const abnormalityIds = results[section.data.variableIds[0]]?.abnormalityValueIds;
        return {
            status: abnormalityIds?.length ? 'abnormal' : 'normal',
            trend,
            value: latestResultsPerVarId
                .map(result => result?.timestamp === latestTimestamp ? String(result.value) : '-')
                .join('/'),
            abnormalityValueIds: abnormalityIds,
        };
    };
    onClick = (e, section) => {
        e.stopPropagation();
        this.props.onClick?.(section);
    };
    // ######################## Render ########################
    render() {
        const sections = this.getSections();
        return _jsxs(Grid, { className: 'c__vitals', onClick: e => this.onClick(e), children: [this.render_Cell_Header(), sections.map(this.render_Cell_Section)] });
    }
    render_Cell_Header = () => {
        return _jsx(LL_V_L, { className: 'vitals-cell header', children: _jsx("h1", { children: "Vitals" }) });
    };
    render_Cell_Section = (section, index) => {
        const results = this.getResultsForSection(section);
        const cellResult = this.getCellResult(section, results);
        const tooltipResults = translate_VitalsResult_TooltipData(section, results);
        tooltipResults.abnormalityValueIds = cellResult.abnormalityValueIds;
        return _jsx(Tooltip_Finding_Vitals, { modules: this.modules, data: tooltipResults, onTooltipOpened: () => this.props.onCellTooltipOpen?.(section), title: section.label, children: _jsxs(LL_H_C, { className: _className('vitals-cell', cellResult.status), onClick: e => this.onClick(e, section), children: [_jsx("h1", { children: section.data.abbreviation ?? 'N/A' }), _jsxs(LL_H_C, { className: 'vitals-cell-value', children: [this.render_Trend(cellResult), cellResult.value] })] }) }, index);
    };
    render_Trend = (cellResult) => {
        switch (cellResult.trend) {
            case 'up':
                return _jsx(ICONS.arrowLong.component, { className: 'up' });
            case 'down':
                return _jsx(ICONS.arrowLong.component, { className: 'down' });
            default:
                return;
        }
    };
}
//# sourceMappingURL=Component_Vitals.js.map